import { ActionKey, ItemMenuProps, MenuItem } from '../Types'

import { useRemovable } from './hooks/useRemovable'
import { useItemContextMenu } from './hooks/useItemContextMenu'
import { useEditable } from './hooks/useEditable'
import { useHandbookItems } from 'components/Handbook2_0/Sidebar/HandbookItemProvider'
import { useCopyable } from './hooks/useCopyable'
import { BaseMenu } from '../BaseMenu'

export const SectionItemMenu = ({ item, onEdit, ...props }: ItemMenuProps) => {
  const { removable, handleRemove } = useRemovable(item, undefined)
  const { editable, handleEdit } = useEditable(item, 'Rename section', onEdit)
  const { copyable, handleCopy } = useCopyable(item, 'Duplicate section')
  const { visible, setVisible, handleAction } = useItemContextMenu({
    handlers: [handleRemove, handleEdit, handleCopy],
  })
  const { currentHandbook: handbook } = useHandbookItems()
  const disabledKeys = new Set<ActionKey>()
  if (handbook?.current_user_access && ['read', 'comment'].includes(handbook.current_user_access)) {
    disabledKeys.add(ActionKey.delete)
    disabledKeys.add(ActionKey.edit)
  }

  const menus: MenuItem[][] = [[...copyable, ...editable, ...removable]]

  return (
    <>
      <BaseMenu
        menus={menus}
        handleAction={handleAction}
        visible={visible}
        setVisible={setVisible}
        item={item}
        {...props}
      />
    </>
  )
}
